<template>
  <mf-loading-dialog :loading="loader">
    <v-row no-gutters class="py-3">
      <span v-if="unitSelected" class="section-title">{{ `Ofertas em destaque na Loja ${unitSelected.id_erp} - ${unitSelected.name}` }}</span>
      <v-spacer />
      <mf-select-units-dialog
        template-type="button"
        btn-content="Escolher outra loja"
        single-select
        required
        label="Lojas"
        hide-ecommerce-configuration
        :selected-units.sync="unitDialogSelected"
        :units="units"
        :tag-list="tagList"
        :group-list="unitsGroups"
      />
    </v-row>
    <highlighted-offers v-if="$getAllowedModules()['mobile']" :unit-selected="unitSelected" type="ativaveis" class="mb-3" />
    <highlighted-offers :unit-selected="unitSelected" type="livres" />
  </mf-loading-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import isEmpty from 'lodash/isEmpty'
export default {
  components: {
    HighlightedOffers: () => import('@/modules/mobile/ofertas/views/components/HighlightedOffers.vue'),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.units.length === 0) {
        vm.$store.dispatch('getStates', ['fetchUnits'])
      }
    })
  },
  data: () => ({
    unitDialogSelected: [],
    unitSelected: {},
  }),
  computed: {
    ...mapGetters(['units', 'tagList', 'unitsGroups']),
    loader() {
      return isEmpty(this.unitSelected)
    },
  },
  watch: {
    unitDialogSelected(unitDialogSelected) {
      this.unitSelected = this.units.find((unit) => unitDialogSelected.includes(unit.id_erp))
    },
    units(units) {
      this.setUnitDialogSelected(units)
    },
  },
  created() {
    this.setUnitDialogSelected(this.units)
  },
  methods: {
    setUnitDialogSelected(units) {
      if (units.length) this.unitDialogSelected = [units[0].id_erp]
    },
  },
}
</script>
